import { useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Button } from "./ui/button";
import { ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const FooterMobile = () => {
  const footerRef = useRef<HTMLElement>(null);

  const footerLinks = {
    Services: [
      ["Brand Growth Solution", "/brandgrowthsolution"],
      ["Smart Tech Solution", "/smarttechsolution"],
      ["WhatsApp & SMS Marketing", "/whatsappsmsmarketing"],
    ],
    Company: [
      ["About Us", "/#whatwedo"],
      ["Contact Us", "?form=contact"],
      ["Portfolio", "/portfolio"],
    ],
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer
      ref={footerRef}
      className="bg-[#0d1821] text-background inset-x-0 bottom-0 overflow-hidden w-full"
    >
      {/* Main Footer Content */}
      <div className="container mx-auto px-8 py-6">
        <div className="grid xl:grid-cols-[1fr_300px_150px] gap-10">
          {/* Brand Section */}
          <div className="footer-item lg:col-span-1 mr-5 max-w-[600px]">
            <div className="flex items-center space-x-2 text-primary">
              <div className="w-2 h-2 bg-[#c3f620] rounded-full animate-pulse" />
              <span className="text-2xl font-normal text-[#f5f5f5]">
                Innovating Since <span className="text-[#c3f620]">2020</span>
              </span>
            </div>
            <p className="text-background/80 leading-relaxed text-md font-poppins pt-6 text-justify">
              Pioneering the future of digital marketing with innovative
              solutions that transform businesses and captivate audiences
              worldwide.
            </p>
          </div>

          {/* Links Sections */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category} className="footer-item">
              <h4 className="text-2xl mb-3 text-[#c3f620]">{category}</h4>
              <ul className="space-y-1">
                {links.map((link) => (
                  <li key={link[0]}>
                    <Link
                      to={link[1]}
                      className="text-background/80 hover:text-primary transition-colors duration-300 relative group text-md font-poppins"
                    >
                      {link[0]}
                      <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background/20">
        <div className="container mx-auto px-8 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="footer-item text-background/60 text-sm mb-4 md:mb-0 text-md font-poppins">
              © 2026 Adszie. All rights reserved. | Privacy Policy | Terms of
              Service
            </div>

            <div className="footer-item flex items-center space-x-4">
              <span className="text-background/60 text-sm">Back to top</span>
              <Button
                variant="outline"
                size="icon"
                onClick={scrollToTop}
                className="bg-transparent border-[#c3f620] text-[#c3f620] hover:bg-[#c3f620] hover:text-[#0d1821] transition-all duration-300"
              >
                <ArrowUp className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Background Elements */}
      <div className="absolute top-10 right-10 w-2 h-2 bg-primary rounded-full animate-twinkle opacity-40" />
      <div
        className="absolute bottom-20 left-20 w-1.5 h-1.5 bg-primary rounded-full animate-twinkle opacity-50"
        style={{ animationDelay: "1s" }}
      />
      <div
        className="absolute top-1/2 right-1/4 w-1 h-1 bg-primary rounded-full animate-twinkle opacity-60"
        style={{ animationDelay: "2s" }}
      />
    </footer>
  );
};

export default FooterMobile;
